import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";

export const getAllCustomers = createAsyncThunk(
  "customers/getAllCustomers",
  async ({ token, ...queryParams }) => {
    const response = await api.get("/users", {
      token,
      params: queryParams,
    });
    return response.data;
  },
);

export const getCustomerById = createAsyncThunk(
  "customers/getCustomerById",
  async ({ token, id }) => {
    const response = await api.get(`/users/${id}`, { token });
    return response.data;
  },
);

export const getPendingCustomers = createAsyncThunk(
  "customers/getPendingCustomers",
  async ({ token, ...queryParams }) => {
    const response = await api.get("/users/pending", {
      token,
      params: queryParams,
    });
    return response.data;
  },
);

export const approveCustomer = createAsyncThunk(
  "customers/approveCustomer",
  async ({ token, id }) => {
    const response = await api.patch(`/users/approve/${id}`, { token });
    return response.data;
  },
);

export const rejectCustomer = createAsyncThunk(
  "customers/rejectCustomer",
  async ({ token, id }) => {
    const response = await api.patch(`/users/reject/${id}`, { token });
    return response.data;
  },
);

export const deleteCustomer = createAsyncThunk(
  "customers/deleteCustomer",
  async ({ token, id }) => {
    const response = await api.delete(`/users/${id}`, { token });
    return response.data;
  },
);

export const suspendCustomer = createAsyncThunk(
  "customers/suspendCustomer",
  async ({ token, id }) => {
    const response = await api.patch(`/users/suspend/${id}`, { token });
    return response.data;
  },
);

export const activateCustomer = createAsyncThunk(
  "customers/activateCustomer",
  async ({ token, id }) => {
    const response = await api.patch(`/users/activate/${id}`, { token });
    return response.data;
  },
);

export const permanentlySuspendCustomer = createAsyncThunk(
  "customers/permanentlySuspendCustomer",
  async ({ token, id }) => {
    const response = await api.patch(`/users/permanently-suspend/${id}`, { token });
    return response.data;
  },
);
